import { Component } from '@theme/component';

/**
 * "Add 1 more" button in the cart drawer's free-shipping progress banner.
 * Reuses the existing per-line quantity stepper's plus button rather than
 * re-implementing cart update logic, so it stays in sync with however the
 * theme currently handles cart line updates.
 */
class CartShippingProgress extends Component {
  addOneMore() {
    const plusButton = document.querySelector('.cart-drawer .quantity-plus');
    if (plusButton instanceof HTMLElement) {
      plusButton.click();
    }
  }
}

if (!customElements.get('cart-shipping-progress')) {
  customElements.define('cart-shipping-progress', CartShippingProgress);
}
